import { render, staticRenderFns } from "./borrowAndReturnTableTwo.vue?vue&type=template&id=67aa0bda&scoped=true&"
import script from "./borrowAndReturnTableTwo.vue?vue&type=script&lang=js&"
export * from "./borrowAndReturnTableTwo.vue?vue&type=script&lang=js&"
import style0 from "./borrowAndReturnTableTwo.vue?vue&type=style&index=0&id=67aa0bda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67aa0bda",
  null
  
)

export default component.exports